import {CircularProgress, Dialog, DialogTitle, Paper} from '@material-ui/core'
import {BusyContent, BusyMessage, BusyWarning} from './styled'

export type BusyDialogProps = {
  message?: string
}

const BusyDialog: React.FC<BusyDialogProps> = ({message}: BusyDialogProps) => {
  const open = message !== undefined && message.length > 0
  return (
    <Dialog open={open ? open : false}>
      <BusyContent>
        <DialogTitle>
          <BusyMessage align="center">{message}</BusyMessage>
          <BusyWarning align="center">
            Do not close this page, or hit the 'back' button.
          </BusyWarning>
        </DialogTitle>
        <Paper elevation={0}>
          <CircularProgress color="inherit" />
        </Paper>
      </BusyContent>
    </Dialog>
  )
}

export default BusyDialog
